<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Recipient Death
    </template>
    <template #body>
      <div class="sections">
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="causeOfDeathCategory"
              disabled
              label="Cause of Death Category"
            />
          </div>

          <div class="col-3">
            <ADSTextInput
              v-model="causeOfDeathType"
              class="causeOfDeathType"
              disabled
              label="Cause of Death Type"
            />
          </div>


          <div class="col-2">
            <ADSTextInput
              v-model="causeOfDeathTypeOther"
              disabled
              label="Cause of Death Type Other"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="deathDate"
              disabled
              label="Death Date"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="deathDateEstimated"
              disabled
              label="Estimated"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="comments"
              class="comments"
              disabled
              label="Comments"
            />
          </div>
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>

<script>
import _ from 'lodash';

export default {
  name: "RecipientDeathSectionDetails",
  props: {
    patient: {
      type: Object,
      default: null,
    },
    patientBundle: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      causeOfDeathCategory: this.getCauseDeathCategory( this.patientBundle ),
      causeOfDeathType: this.getCauseDeathType( this.patientBundle ),
      causeOfDeathTypeOther: this.getCauseDeathTypeOther( this.patientBundle ),
      deathDate: this.getDeathDate( this.patientBundle ),
      deathDateEstimated: this.getDeathDateEstimated( this.patientBundle ),
      comments: this.getComments( this.patientBundle ),
    };
    },
   mounted() {
    
    },
  methods: {
    combineProps() {
      return `${this.patient}`;
    },
    getCauseDeathCategory( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let causeOfDeathCategory = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#390' ) ) ;
      if( causeOfDeathCategory && causeOfDeathCategory[ 0 ] ) {
        return _.get( causeOfDeathCategory[ 0 ], 'resource.component[0].valueString' ); 
      } 
      }
    },
    getCauseDeathType( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let causeOfDeathCategory = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#391' ) ) ;
      if( causeOfDeathCategory && causeOfDeathCategory[ 0 ] ) {
        return _.get( causeOfDeathCategory[ 0 ], 'resource.component[0].valueString' ); 
      } 
      }
    },
    getCauseDeathTypeOther( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let causeOfDeathCategory = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#392' ) ) ;
      if( causeOfDeathCategory && causeOfDeathCategory[ 0 ] ) {
        return _.get( causeOfDeathCategory[ 0 ], 'resource.component[0].valueString' ); 
      } 
      }
    },
    getDeathDate( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let deathDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#388' ) ) ;
      if( deathDate && deathDate[ 0 ] ) {
        return _.get( deathDate[ 0 ], 'resource.component[0].valueDateTime' ); 
      } 
      }
    },
    getDeathDateEstimated( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let deathDateEstimated = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#389' ) ) ;
      if( deathDateEstimated && deathDateEstimated[ 0 ] ) {
        return _.get( deathDateEstimated[ 0 ], 'resource.component[0].valueBoolean', '' ).toString();
      } 
      }
    },
    getComments( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let comments = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#393' ) ) ;
      if( comments && comments[ 0 ] ) {
        return _.get( comments[ 0 ], 'resource.component[0].valueString', '' );
      } 
      }
    },
  },
};
</script>

<style scoped>

/* .card {
  height: 260px;
} */

.sectionHeading {
  background-color: rgb(59, 53, 53);
  color: white;
  padding-left: 5px;
}

.page-content .summary-card .card-header .summary-name {
  padding-left: 35px;
  padding-top: 4px;
  font-weight: 300;
}

.sections {
  font-size: 15px;
  height: 260px;
  width: 1400px;
  /* overflow: scroll; */
  padding-left: 10px;
  padding-top: 5px;
}

.inputDisplay {
border-style: solid;
background-color: #F2F2F2;
}

.inputDisplayCauseDeathType {
  border-style: solid;
  width: 300px;
  background-color: #F2F2F2;
}

.inputDisplayComments {
  border-style: solid;
  width: 350px;
  background-color: #F2F2F2;
}

.fieldName {
  font-weight: 700;
  font-size: 0.875rem;
  padding-top: 5.5px;
  padding-bottom: 2.5px;
}

:deep(.afflo-ds-form-control) {
  width: max-content;
}

:deep(label) {
  width: max-content;
}

:deep(.causeOfDeathType .afflo-ds-form-control) {
  width: 330px;
}

:deep(.comments .afflo-ds-form-control) {
  width: 400px;
}

</style>
